import z from "zod";

const envVariables = {
    appName: import.meta.env.VITE_APP_NAME,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL
};

const envSchema = z.object({
    appName: z.string().nonempty(),
    apiBaseUrl: z.string().nonempty()
    // isProd: z.enum(["true", "false", ""])
    //     .optional()
    //     .transform((val) => val === "true"),
});

// not safe parcing so the program ends before staring
export const EnvVariables = envSchema.parse(envVariables);